<div style="display: none">
    <img src="/assets/img/about.jpg" alt="" srcset="">
    <img src="/assets/img/career.jpg" alt="" srcset="">
    <img src="/assets/img/contact.jpg" alt="" srcset="">
    <img src="/assets/img/services.jpg" alt="" srcset="">
    <img src="/assets/img/BW-Logo.png" alt="" srcset="">
    <img src="/assets/img/Mission-Statements.png" alt="" srcset="">
</div>